/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MaintenanceTasksDtoPagedListData } from '../models/MaintenanceTasksDtoPagedListData';
import type { MaintenanceTaskSetPriorityInput } from '../models/MaintenanceTaskSetPriorityInput';
import type { MaintenanceTasksPriorityEnum } from '../models/MaintenanceTasksPriorityEnum';
import type { MaintenanceTasksSetStatusInput } from '../models/MaintenanceTasksSetStatusInput';
import type { MaintenanceTasksSingleDto } from '../models/MaintenanceTasksSingleDto';
import type { MaintenanceTasksStatusEnum } from '../models/MaintenanceTasksStatusEnum';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { StatusHistoryDto } from '../models/StatusHistoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MaintenanceTasksService {

  /**
   * @param presets 
   * @param branchId 
   * @param status
 *
 * 1 = ReadyToStart
 *
 * 2 = Pending
 *
 * 3 = InProcess
 *
 * 4 = Completed
   * @param priority
 *
 * 1 = High
 *
 * 2 = Medium
 *
 * 3 = Low
 *
 * 4 = Urgent
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns MaintenanceTasksDtoPagedListData Success
   * @throws ApiError
   */
  public static getMaintenanceTasks(
presets?: string,
branchId?: number,
status?: Array<MaintenanceTasksStatusEnum>,
priority?: MaintenanceTasksPriorityEnum,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<MaintenanceTasksDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/maintenance-tasks',
      query: {
        'Presets': presets,
        'BranchId': branchId,
        'Status': status,
        'Priority': priority,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postMaintenanceTasks(
formData?: {
Description: string;
Priority: MaintenanceTasksPriorityEnum;
UserAssignedId?: number;
ExternalContractorAssignedId?: number;
EstimatedBudgetExVat: number;
FinalCostsExVat: number;
NewPhotos?: Array<Blob>;
BranchId?: number;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/maintenance-tasks',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns MaintenanceTasksSingleDto Success
   * @throws ApiError
   */
  public static getMaintenanceTasks1(
id: number,
): CancelablePromise<MaintenanceTasksSingleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/maintenance-tasks/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static putMaintenanceTasks(
id: number,
formData?: {
DeletePhotos?: Array<number>;
Description: string;
Priority: MaintenanceTasksPriorityEnum;
UserAssignedId?: number;
ExternalContractorAssignedId?: number;
EstimatedBudgetExVat: number;
FinalCostsExVat: number;
NewPhotos?: Array<Blob>;
BranchId?: number;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/maintenance-tasks/{id}',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteMaintenanceTasks(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/maintenance-tasks/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns StatusHistoryDto Success
   * @throws ApiError
   */
  public static putMaintenanceTasksSetStatus(
id: number,
requestBody?: MaintenanceTasksSetStatusInput,
): CancelablePromise<Array<StatusHistoryDto>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/maintenance-tasks/{id}/set-status',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putMaintenanceTasksSetPriority(
id: number,
requestBody?: MaintenanceTaskSetPriorityInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/maintenance-tasks/{id}/set-priority',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
